<template>
	<div id='project' class='container'> 
		<h6 class='heading'>{{$t('h-projects')}}</h6>
		<div class="row">
			<div class="col p-1"><p>{{$t('project-content-1')}}<router-link to="/projects" class='link2 f-right'>{{$t('project-content-3')}}</router-link><br>{{$t('project-content-2')}}</p></div>	
			<div class="col">
			
			</div>	
		</div>
		
		
		<hooper>
		

			<slide>
				<router-link to="/projects/crazetrip"><img src="img/projects/crazetrip.webp" alt="crazetrip" height="500px" width="870px"></router-link>
			</slide>
			<slide>
				
				<router-link to="/projects/suzuki"><img src="img/projects/suzuki.webp" alt="suzuki" height="500px" width="870px"></router-link>
			</slide>
		
			
		
		
			<hooper-navigation slot="hooper-addons"></hooper-navigation>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
		</hooper>
	
		
	</div>
</template>

<script>

import 'hooper/dist/hooper.css';
import { Hooper, Slide,  Pagination as HooperPagination,Navigation as HooperNavigation } from 'hooper';


export default {
	name:"page-project",

    components: {
		Hooper,
		Slide,
		HooperPagination,
		HooperNavigation
    }
}
</script>

